module.exports = __webpack_public_path__ + "static/media/githubIcon.d0805040.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/githubIcon.svg
// module id = 92
// module chunks = 0